(function() {
  if (!document.getElementById('bikini-price-display')) return;

  var lastPriceText = '';

  function getVisiblePrices() {
    var prices = [];
    document.querySelectorAll('.po-extra-price').forEach(function(el) {
      // Check if OPTIS has hidden the wrapping container
      var container = el.closest('.po-stack');
      if (container && window.getComputedStyle(container).display === 'none') return;
      var match = el.textContent.match(/[\d.]+/);
      if (match) prices.push(parseFloat(match[0]));
    });
    return prices;
  }

  function updatePrice() {
    var el = document.getElementById('bikini-price-display');
    if (!el) return;

    var prices = getVisiblePrices();
    var text;

    if (prices.length === 0) {
      text = '—';
    } else if (prices.length === 1) {
      text = '£' + prices[0].toFixed(2);
    } else {
      var min = Math.min.apply(null, prices);
      var max = prices.reduce(function(a, b) { return a + b; }, 0);
      text = '£' + min.toFixed(2) + ' \u2013 £' + max.toFixed(2);
    }

    if (text !== lastPriceText) {
      el.textContent = text;
      lastPriceText = text;
    }
  }

  setInterval(updatePrice, 200);
  updatePrice();
})();